export const ARTWORK_PAGES_TITLE = [
  {
    path: "/artwork",
    title: "Artwork - Search",
  },
  {
    path: "/artwork/approvals",
    title: "Artwork - Approval Requests",
  },
  {
    path: "/artwork/collections/create",
    title: "Artwork - Create New Collection",
  },
  {
    path: "/artwork/collections/detail/*",
    title: "Artwork - Collection Detail",
  },
  {
    path: "/artwork/printing-technique/create",
    title: "Artwork - Create new Artwork",
  },
]